import React from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import FormRow from '../FormRow';
import { LISTING_RATINGS } from '../../constants';
import { Textarea, RadioGroup, HandleError } from '../form';
import FormHeader from '../FormHeader';

function FormListing() {
  return (
    <>
      <Paper sx={{ padding: '2rem', marginBottom: '1rem' }}>
        <FormHeader
          title="Description"
          description="Say something about what make this apartment special"
        />
        <FormRow label="" hideDivider>
          <Textarea
            name="commentsMarkdown"
          />
        </FormRow>
      </Paper>
      <Paper sx={{ padding: '2rem', marginBottom: '1rem' }}>
        <FormHeader
          title="Listing Rating"
          description="Rate the apartment and building details"
        />
        <Grid container spacing={1}>
          {LISTING_RATINGS.map((item, index) => (
            <FormRow
              label={item.label}
              key={index}
              hideDivider={index === LISTING_RATINGS.length - 1}
            >
              <RadioGroup
                compact
                list={item.list}
                name={`ratings.${item.name}`}
              />
              <HandleError
                name={`ratings.${item.name}`}
              />
            </FormRow>
          ))}
        </Grid>
      </Paper>
    </>
  );
}

export default FormListing;
